export const isGuestMessageEnabled = ({
  isDealerAd,
  isPintAd,
  isSM360Ad,
  isVerticalAd,
}: {
  isPintAd: boolean
  isSM360Ad: boolean
  isDealerAd: boolean
  isVerticalAd: boolean
}): boolean => {
  return (isPintAd || isSM360Ad || isDealerAd) && isVerticalAd
}
